import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8b66f4ba18594255b708917c7775945f.jpg"
          alt="Familia conectando"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/60 to-white/50"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-white/90 backdrop-blur-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/8dee5cc1-3646-466d-be88-4d9c0487265e.png" 
              alt="Logo" 
              className="h-10 sm:h-12 w-auto"
            />
            <span className="font-serif text-base sm:text-xl font-semibold text-gray-900">
              El poder de ser yo
            </span>
          </div>
          <button
            onClick={() => scrollToSection('cta')}
            className="px-4 sm:px-6 py-2 sm:py-2.5 bg-gradient-to-r from-orange-500 to-rose-500 text-white rounded-full font-semibold text-sm sm:text-base transition-all whitespace-nowrap cursor-pointer hover:shadow-xl hover:scale-105 active:scale-95 animate-pulse"
          >
            Comprar ahora
          </button>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center pt-20 sm:pt-0">
        <div className="inline-block mb-4 sm:mb-6 px-4 sm:px-5 py-2 bg-emerald-600/90 backdrop-blur-sm rounded-full">
          <span className="text-white text-xs sm:text-sm font-medium tracking-wide">Ebook de crianza consciente</span>
        </div>

        <h1 className="font-serif text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
          🌱 El poder de ser yo
        </h1>

        <p className="text-lg sm:text-xl md:text-2xl text-gray-800 font-medium mb-6 sm:mb-10 max-w-3xl mx-auto leading-relaxed">
          Un libro para fortalecer el amor propio, la calma y la conexión emocional en familia
        </p>

        <p className="text-base sm:text-lg text-gray-700 mb-8 sm:mb-12 max-w-2xl mx-auto leading-relaxed">
          En un mundo lleno de prisa, comparación y sobreestimulación, este libro se convierte en un refugio de calma para niños y padres.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
          <button
            onClick={() => scrollToSection('cta')}
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-orange-500 to-rose-500 text-white rounded-full text-base sm:text-lg font-bold hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer hover:scale-110 active:scale-95 shadow-lg"
          >
            🎁 Obtener por $9 USD
          </button>
          <button
            onClick={() => scrollToSection('content')}
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white border-2 border-gray-900 text-gray-900 rounded-full text-base sm:text-lg font-bold hover:bg-gray-900 hover:text-white transition-all whitespace-nowrap cursor-pointer hover:scale-105 active:scale-95 shadow-md"
          >
            Ver contenido
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden sm:block">
        <div className="w-6 h-10 border-2 border-gray-900 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-gray-900 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
